"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAVORIT_SERVICES_ICONS = void 0;
var _firstBeachLine = _interopRequireDefault(require("./icons/first-beach-line.svg"));
var _twoBeachLine = _interopRequireDefault(require("./icons/two-beach-line.svg"));
var _thirdBeachLine = _interopRequireDefault(require("./icons/third-beach-line.svg"));
var _nonAlco = _interopRequireDefault(require("./icons/non-alco.svg"));
var _aquapark = _interopRequireDefault(require("./icons/aquapark.svg"));
var _wiFi = _interopRequireDefault(require("./icons/wi-fi.svg"));
var _cay = _interopRequireDefault(require("./icons/cay.svg"));
var _bay = _interopRequireDefault(require("./icons/bay.svg"));
var _ski = _interopRequireDefault(require("./icons/ski.svg"));
var _sandy = _interopRequireDefault(require("./icons/sandy.svg"));
var _pebble = _interopRequireDefault(require("./icons/pebble.svg"));
var _sandyPebble = _interopRequireDefault(require("./icons/sandy-pebble.svg"));
var _largeArea = _interopRequireDefault(require("./icons/large-area.svg"));
var _spa = _interopRequireDefault(require("./icons/spa.svg"));
var _adults = _interopRequireDefault(require("./icons/adults.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var FAVORIT_SERVICES_ICONS = exports.FAVORIT_SERVICES_ICONS = {
  one_line_beach: _firstBeachLine.default,
  two_line_beach: _twoBeachLine.default,
  next_beach_line: _thirdBeachLine.default,
  non_alcoholic: _nonAlco.default,
  aquapark: _aquapark.default,
  wifi: _wiFi.default,
  cay: _cay.default,
  bay: _bay.default,
  ski_slopes: _ski.default,
  sandy: _sandy.default,
  pebble: _pebble.default,
  sandy_pebble: _sandyPebble.default,
  large_area: _largeArea.default,
  spa: _spa.default,
  adults: _adults.default
};